export type MillId = 11 | 12;

export interface MillConfig {
	id: MillId;
	name: string;
}

export const MILL_1: MillConfig = {
	id: 11,
	name: "Mill 1",
};

export const MILL_2: MillConfig = {
	id: 12,
	name: "Mill 2",
};

export const MILLS: Record<MillId, MillConfig> = {
	11: MILL_1,
	12: MILL_2,
};

export const DEFAULT_MILL = MILL_2;

class AssetContextService {
	private _assetId: number | undefined;

	setAssetId(assetId: number | undefined) {
		this._assetId = assetId;
	}

	getAssetId(): number | undefined {
		return this._assetId;
	}
}

export const assetContext = new AssetContextService();
